import { useStore } from '@nanostores/react';
import type { Theme } from 'react-toastify';
import { type HighlighterGeneric, type BundledLanguage, type BundledTheme, createHighlighter } from 'shiki';
import { themeStore } from '~/lib/stores/theme';
import { classNames } from '~/utils/classNames';

const highlighterOptions = {
  langs: ['shell'],
  themes: ['light-plus', 'dark-plus'],
};

const shellHighlighter: HighlighterGeneric<BundledLanguage, BundledTheme> =
  import.meta.hot?.data.shellHighlighter ?? (await createHighlighter(highlighterOptions));

if (import.meta.hot) {
  import.meta.hot.data.shellHighlighter = shellHighlighter;
}

export interface ShellCodeBlockProps {
  className?: string;
  code: string;
  theme?: Theme;
}

export function ShellCodeBlock({ className, theme, code }: ShellCodeBlockProps) {
  const currentTheme = useStore(themeStore);
  theme ??= currentTheme;

  return (
    <div
      className={classNames('text-xs w-full', className)}
      dangerouslySetInnerHTML={{
        __html: shellHighlighter.codeToHtml(code, {
          lang: 'shell',
          theme: theme === 'light' ? 'light-plus' : 'dark-plus',
        }),
      }}
    />
  );
}
